module.exports = __webpack_public_path__ + "static/Inter-Bold-001893789f7f342b520f29ac8af7d6ca.woff";